// The framework-free entry point.
//
// Everything Voxide actually does — the WebSocket session, the audio graph,
// action registration, tool dispatch, state binding, wake word — lives in
// VoxideClient and has never imported React. The only reason it could not be
// used from Vue, Svelte, Django, Rails, Go templates or a plain <script> tag is
// that `index.ts` re-exports <VoxideWidget> alongside it, so any bundler
// resolving that module pulls React in whether the caller wants it or not.
//
// This file is that same surface with the three React exports removed. It adds
// no behaviour and changes none. `index.ts` is untouched, so every existing
// import keeps resolving to exactly what it resolved to before.
//
// Consumers reach it as:
//   import { VoxideClient } from "@voxide/react/core";   // bundlers
//   <script src=".../voxide.browser.js"></script>        // window.Voxide
//
// Do not export anything from here that transitively imports react,
// react-dom, framer-motion or lucide-react. `npm run check:core` fails the
// build if that happens, because nothing else would notice until a Vue user
// filed the bug.

export { VoxideClient, DEFAULT_BASE_URL, resolveLiveUrl } from "./VoxideClient";
// getSnapshot() returns this, and it is declared in VoxideClient rather than
// types.ts, so the `export type *` below does not reach it.
export type { VoxideVoiceSnapshot } from "./VoxideClient";

// Pulled from ./VoxideClient rather than ./useVoxideVoice, which is where the
// React entry happens to re-export it from. Going through that module would
// drag the whole hook, and therefore React, back into this graph.

/** Feature-detect before offering wake-word affordances Firefox and Safari
 *  cannot honour. */
export { isWakeWordSupported } from "./WakeWordListener";
export type { WakeWordFailure } from "./WakeWordListener";

export type * from "./types";
